const locale = {
	// #region Commercial Campaigns fields
	DETAILS_COMMERCIALCAMPAIGNS_FIELD_TITLE: 'Title',
	DETAILS_COMMERCIALCAMPAIGNS_FIELD_STATUS: 'Commercial Campaign Status',
	DETAILS_COMMERCIALCAMPAIGNS_FIELD_TYPE: 'Commercial Campaign Type',
	DETAILS_COMMERCIALCAMPAIGNS_FIELD_ASSIGNED_USER: 'Internal assigned User',
	DETAILS_COMMERCIALCAMPAIGNS_FIELD_ASSIGNED_USER_2: 'External assigned User',
	DETAILS_COMMERCIALCAMPAIGNS_FIELD_DATE_FROM: 'Start date',
	DETAILS_COMMERCIALCAMPAIGNS_FIELD_DATE_TO: 'End date',
	DETAILS_COMMERCIALCAMPAIGNS_FIELD_PROGRESS: 'Progress',
	DETAILS_COMMERCIALCAMPAIGNS_FIELD_WARNING: 'Warning',
	DETAILS_COMMERCIALCAMPAIGNS_FIELD_BLOCKED: 'Blocked',
	DETAILS_COMMERCIALCAMPAIGNS_FIELD_TAGS: 'Tags',
	DETAILS_COMMERCIALCAMPAIGNS_FIELD_EXPENSES: 'Expenses',
	// #endregion

	// #region Commercial Campaigns details right sidebar
	COMMERCIALCAMPAIGNS_STATS_SECTION: 'Statistics',
	COMMERCIALCAMPAIGNS_STATISTICS_VALUE_EXPENSES: 'Expenses',
	COMMERCIALCAMPAIGNS_STATISTICS_VALUE_PLANNED: 'Opportunity value',
	COMMERCIALCAMPAIGNS_STATISTICS_N_OPPORTUNITIES: 'N° Opportunities',
	COMMERCIALCAMPAIGNS_STATISTICS_N_LEADS: 'N. Leads',
	COMMERCIALCAMPAIGNS_STATISTICS_N_CUSTOMERS: 'N. Customers',
	COMMERCIALCAMPAIGNS_STATISTICS_LEAD_CONVERSION: 'Lead Conversion Rate',
	COMMERCIALCAMPAIGNS_STATISTICS_CAC: 'Customer Acquisition Cost (CAC)',
	COMMERCIALCAMPAIGNS_STATISTICS_CPA: 'Cost per Action (CPA)',
	// #endregion

	// #region Commercial Campaigns Add Rows section
	COMMERCIALCAMPAIGNS_SECTION_ADD_TITLE: 'Add to list',
	COMMERCIALCAMPAIGNS_SECTION_ADD_DESCRIPTION_COMPANIES:
		"Add a new or existing Company who partecipated in this Commercial Campaign (if it doesn't exist will be automatically added to the database and it will be available for use in any recall action).",
	COMMERCIALCAMPAIGNS_SECTION_ADD_DESCRIPTION_PEOPLE:
		"Add a new or existing Person who partecipated in this Commercial Campaign (if it doesn't exist will be automatically added to the database and it will be available for use in any recall action).",

	COMMERCIALCAMPAIGNS_SECTION_ADD_COMPANIES_TITLE: 'Add filtered Companies',
	COMMERCIALCAMPAIGNS_SECTION_ADD_PEOPLE_TITLE: 'Add filtered People',

	COMMERCIALCAMPAIGNS_SECTION_COPY_TITLE: 'Import from',
	COMMERCIALCAMPAIGNS_SECTION_COPY_MARKETINGACTION: 'Marketing Action',
	COMMERCIALCAMPAIGNS_SECTION_COPY_DEM: 'DEM',
	COMMERCIALCAMPAIGNS_SECTION_COPY_COMMERCIALCAMPAIGN: 'Commercial Campaign',

	COMMERCIALCAMPAIGNS_DIALOG_TITLE_ADD_RESULT: 'Do you want to add those elements?',
	// #endregion

	// #region Commercial Campaigns Delete Rows section
	COMMERCIALCAMPAIGNS_SECTION_EMPTY_TITLE: 'Clear the list',
	COMMERCIALCAMPAIGNS_SECTION_EMPTY_DESCRIPTION:
		'With this function you can clear the list (removing ALL the added elements)',
	COMMERCIALCAMPAIGNS_EMPTY_BUTTON_CLEAR: 'Clear'
	// #endregion
};

export default locale;
